import React from "react";
import {useSearchParams} from "react-router-dom";
import {Box, Stack, Tab, Tabs, Typography} from "@mui/material";
import {useRegistryProject} from "../RegistryProjectContext";
import {RegistryDialplanPage} from "../dialplan/RegistryDialplanPage";
import {RegistryAgentGroupsSettings} from "../settings/RegistryAgentGroupsSettings";

const TABS = [
  {value: "dialplan", label: "Dialplan", roles: ["ADMIN"], Component: RegistryDialplanPage},
  {value: "agent-groups", label: "Agent Groups", roles: ["ADMIN", "MANAGER"], Component: RegistryAgentGroupsSettings, card: true},
];

// SIP configuration of a registry project: the dialplan extensions (ADMIN) and the agent groups (ADMIN / MANAGER)
export const RegistrySipConfigurationPage = () => {
  const {role} = useRegistryProject();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = TABS.filter(tab => tab.roles.includes(role));
  const activeTab = tabs.find(tab => tab.value === searchParams.get("tab")) || tabs[0];
  const handleTabChange = (e, value) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      if (value === tabs[0].value) next.delete("tab"); else next.set("tab", value);
      return next;
    }, {replace: true});
  };

  if (!activeTab) return null;

  return (
    <Stack gap={3} sx={{p: {xs: 2, md: 3}, maxWidth: {xs: "calc(100% - 16px)", md: "calc(100% - 128px)"}, width: "100%", mx: "auto", boxSizing: "border-box"}}>
      <Box>
        <Typography sx={{fontSize: 11, fontWeight: 600, letterSpacing: "0.12em", color: "#8491F7"}}>TELEPHONY</Typography>
        <Typography component={"h1"} sx={{fontSize: {xs: 22, md: 26}, fontWeight: 700, color: "#23264D", letterSpacing: "-0.02em"}}>
          SIP Configuration
        </Typography>
        <Typography sx={{fontSize: 14, color: "#6B6B80"}}>
          Extensions callers reach, and the agent groups calls can be transferred to
        </Typography>
        {tabs.length > 1 && (
          <Tabs
            value={activeTab.value}
            onChange={handleTabChange}
            sx={{
              mt: 1.5, minHeight: 44, borderBottom: "1px solid #ECECF3",
              "& .MuiTab-root": {textTransform: "none", minHeight: 44, minWidth: "auto", fontWeight: 700, fontSize: 13, px: 0, mr: 3, color: "#8A8AA0", "&.Mui-selected": {color: "#8491F7"}},
              "& .MuiTabs-indicator": {backgroundColor: "#8491F7"},
            }}
          >
            {tabs.map(tab => <Tab key={tab.value} label={tab.label} value={tab.value}/>)}
          </Tabs>
        )}
      </Box>

      {activeTab.card ? (
        <Box sx={{bgcolor: "#fff", border: "1px solid #ECECF3", borderRadius: "18px", boxShadow: "0 1px 2px rgba(35, 38, 77, 0.04)"}}>
          <activeTab.Component/>
        </Box>
      ) : <activeTab.Component/>}
    </Stack>
  );
};
